import "custom-event-polyfill";
import "@/pages/cmp/usercentricsBrowserSdkPolyfill.js";

import initCmpService from "@/vue/services/cmp/CmpService";
import injectWebpackPublicPath from "@/vue/helper/injectWebpackPublicPath";

init();

export default function init() {
  const cmpScriptElement = document.querySelector(
    "script[data-cmp-setting-id]"
  );
  if (cmpScriptElement) {
    injectWebpackPublicPath(getWebpackPublicPath(cmpScriptElement));
    const settingsId = getAttribute(cmpScriptElement, "data-cmp-setting-id");
    const customerId = getAttribute(cmpScriptElement, "data-cmp-customer-id");
    const customerConsentToken = getAttribute(
      cmpScriptElement,
      "data-cmp-customer-consent-token"
    );
    if (settingsId) {
      initCmpService(
        settingsId,
        getLanguageFromAttributeOrDefault(),
        getAttribute(cmpScriptElement, "data-cmp-hide-on-startup") === "true",
        getAttribute(cmpScriptElement, "data-cmp-use-marker-cookies") !==
          "false",
        getAttribute(cmpScriptElement, "data-cmp-read-only") === "true",
        customerId,
        customerConsentToken
      );
    }
  }
}

function getCmpScript(): Element | null {
  return document.querySelector("script[data-cmp-setting-id]");
}

function getWebpackPublicPath(cmpScriptElement: Element) {
  const srcAttr = getAttribute(cmpScriptElement, "src");
  if (srcAttr) {
    return srcAttr!.substring(0, srcAttr!.indexOf("/cmp/js") + "/cmp/".length);
  }
  return "/";
}

function getAttribute(
  element: Element,
  attributeName: string
): string | undefined {
  const attributeValue = element.getAttribute(attributeName);
  // If dataLayer variable is not defined, GTM will return the string 'undefined'.
  if (
    attributeValue &&
    attributeValue !== "undefined" &&
    attributeValue !== "null"
  ) {
    return attributeValue;
  }
  return undefined;
}

function getLanguageFromAttributeOrDefault() {
  let lang = "de";
  if (document.documentElement.lang) {
    const splitLocale = document.documentElement.lang.split("-");
    if (splitLocale.length) {
      lang = splitLocale[0];
    }
  }
  return lang;
}
